if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // ---- Personalization validation ----
        // If a personalization-field is associated with this form's section,
        // run its validation before doing anything else. If it fails, abort
        // the add-to-cart entirely so the user can't bypass the requirement.
        if (!this.validatePersonalization()) {
          return;
        }
        // ------------------------------------

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      /**
       * Find the personalization-field in the same product section as this
       * form, and call its validateBeforeSubmit() method. If the field is
       * not present or is hidden (non-personalized variant), this returns
       * true and the add-to-cart proceeds normally.
       *
       * Returns false when the field is visible but empty/invalid, in which
       * case we also reset the submit button so the user isn't stuck in a
       * loading state.
       */
      validatePersonalization() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return true;

        const personalizationField = document.querySelector(
          `personalization-field[data-section-id="${sectionId}"]`
        );

        if (!personalizationField) return true;

        // If the custom element hasn't fully upgraded yet, fall back to a
        // direct DOM check so we still block submission.
        if (typeof personalizationField.validateBeforeSubmit !== 'function') {
          const isHidden = personalizationField.classList.contains('hidden');
          if (isHidden) return true;
          const textarea = personalizationField.querySelector('.personalization-textarea');
          const value = textarea ? textarea.value.trim() : '';
          if (value.length === 0) {
            const errorEl = personalizationField.querySelector('.personalization-error');
            if (errorEl) errorEl.hidden = false;
            if (textarea) {
              textarea.classList.add('is-invalid');
              textarea.focus();
            }
            personalizationField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.resetSubmitButton();
            return false;
          }
          return true;
        }

        const isValid = personalizationField.validateBeforeSubmit();
        if (!isValid) {
          this.resetSubmitButton();
        }
        return isValid;
      }

      resetSubmitButton() {
        if (!this.submitButton) return;
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
